import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      width: '100%',
    },
    largeContainer: {
      [muiTheme.breakpoints.up('md')]: {
        minHeight: '100vh',
        display: 'flex',
        alignContent: 'center',
      },
    },
    snap: {},
  }),
  { name: 'GenComplexTabList' },
);

export default useStyles;
